import { createStore, applyMiddleware } from 'redux';
//createStore-Creates a Redux store that holds the complete state tree of your app. There should only be a single store in your app
//Commonly, middlewares are used to deal with asynchronous actions in your app. Redux provides with API called applyMiddleware which allows us to use custom middleware as well as Redux middlewares like redux-thunk and redux-promise. It applies middlewares to store.
//createLogger-This library logs actions in developer console, giving traceable stack of user actions
//commonly used for data fetching
import { thunk } from 'redux-thunk';
import rootReducer from '../_reducers/index'
import persistStore from 'redux-persist/es/persistStore';

export const store = createStore(
    rootReducer,
    applyMiddleware(
        thunk
    )
)
export const persistor = persistStore(store);


